import styled from 'styled-components';

import { getThemeProps } from 'ravenjs/utils/theme';

const TableCellChild = styled.div`
    flex: 1 1 70%;
    display: inline-block;
    ${({ theme }) => theme.media.down('md')`
        font-size: 0.875rem;
    `};
    ${({ noDataAvailable }) => noDataAvailable && { width: '100%' }};
    /**
     * Add all of the remaining styles from the theme
     */
    ${getThemeProps('TableCellChild.styles')};
`;

export default TableCellChild;
